export const links = [
    {
        text: "Invitations",
        to: "/admin/invitations"
    },
    {
        text: "Users",
        to: "/admin/users"
    },
    {
        text: "Subscriptions",
        to: "/admin/subscriptions"
    },
    {
        text: "Logout",
        to: "/logout",
        ignoreRouteParams: true
    }
];

